// extracted by mini-css-extract-plugin
export default {"Search":"styles_Search__N-RBu","searchInput":"styles_searchInput__Pog1J"};